var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestions(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_2529",
    "data-name": "Groupe 2529",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 62.747,
    viewBox: "0 0 64 62.747",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_871",
    "data-name": "Trac\\xE9 871",
    d: "M48,1H5A4,4,0,0,0,1,5V49.646a1,1,0,0,0,1.707.707L14.046,39H48a4,4,0,0,0,4-4V5A4,4,0,0,0,48,1Z",
    fill: "none",
    stroke: "#0d0b0e",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_872",
    "data-name": "Trac\\xE9 872",
    d: "M58,23h1a4,4,0,0,1,4,4V60.841s-1.094,1.341-1.719.695L53.023,53H28a4,4,0,0,1-4-4V45",
    fill: "none",
    stroke: "#0d0b0e",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestions);
export default __webpack_public_path__ + "static/media/questions.b92fc4b9c15a4edfb4af07ef78da3204.svg";
export { ForwardRef as ReactComponent };